unit PrepareOperationType;
{

/* Initial. */

}
interface

uses
  SpecialismType, UserType;

type
  TPrepareOperationType = class
  private
    fPrepareOperationKey: String;
    fName: String;
    fparticularities: String;
    fPrepareAs: TPrepareOperationType;
    fSpecialism: TSpecialismType;
    fCreationDate: String;
    fCreatedBy: TUserType;
    fChangedDate: String;
    fChangedBy: TUserType;
    fActive: Boolean;
  public
    property PrepareOperationKey: String read fPrepareOperationKey;
    property Name: String read fName;
    property Particularities: String read fParticularities;
    property PrepareAs: TPrepareOperationType read fPrepareAs;
    property Specialism: TSpecialismType read fSpecialism;
    property CreationDate: String read fCreationDate;
    property CreatedBy: TUserType read fCreatedBy;
    property ChangedDate: String read fChangedDate;
    property ChangedBy: TUserType read fChangedBy;
    property Active: Boolean read fActive;
  end;

implementation

end.
